export enum ProdOrderResponseEnum{
  success = 0,
  prodOrderMapToGlueset = 1,
  prodOrderMapToSequence = 2,
  prodOrderDeleteNotAllowedDueToState = 3,
  prodOrderDeleteNotAllowedDueToExternalId = 4
}
